import React, {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';
import Navbar from '../Components/Navbar/navbar.jsx';
import ListaClientes from '../Components/ListaCliente/listacliente.jsx';
import './home.css';
import firebase from '../Config/firebase';
import { collection, getFirestore, query, orderBy, getDocs, doc, deleteDoc } from 'firebase/firestore';
import SweetAlert from 'react-bootstrap-sweetalert';
import clientesPDF from '../Reports/clientes.jsx';

function Home(){
  const [clientes,setClientes] = useState([]);
  const [busca,setBusca] = useState([]);
  const [texto,setTexto] = useState([]);
  const [excluido,setExcluido] = useState([]);
  const [confirmacao,setConfirmacao] = useState(false);
  const [confirmacaoId,setConfirmacaoId] = useState('');

  const handleInputChange = (event) => {
    const valorNormal = event.target.value;
    const valorMaiusculo = valorNormal.toUpperCase();
    setTexto(valorMaiusculo);
  };

  function deleteUser(id){
    const db = getFirestore();
    deleteDoc(doc(db,'clientes',id)).then(()=>{
       setExcluido(id);
       setConfirmacao(false);
    })
   }

   function confirmDeleteUser(id){
    setConfirmacaoId(id);
    setConfirmacao(true);
   }

  useEffect(() => {
        let listacli = [];
        const fetchData = async () => {
          const db = getFirestore();
          const clientesRef = collection(db, 'clientes');
          const q = query(clientesRef, orderBy('nome'));
          const snapshot = await getDocs(q);
          
          snapshot.forEach((doc) => {
            if (doc.data().nome.indexOf(busca) >= 0){
             listacli.push({
              id: doc.id,
              nome: doc.data().nome,
              siape: doc.data().siape,
              cpf: doc.data().cpf,
              processo: doc.data().processo,
              valor: doc.data().valor,
              alter: doc.data().alter
             })
            }
          });
          setClientes(listacli);
        };
      
        fetchData();
    }, [busca,excluido]);
    
    return <div>
           <Navbar/>
           <div className="container-fluid titulo">
           <h1> Cadastro de Sindicalizados na Ação do PSS</h1>
           <div className="row">
                <div className="col-4">
                <Link to="../app/novocliente" className="btn btn-primary w-100 py-2" type="button">Adicionar Sindicalizado</Link>
                <button onClick={(e) => clientesPDF(clientes)} className="btn btn-danger" type="button" id="button-addon2"> <i className="fa-solid fa-file-pdf"></i> Gerar PDF</button>
                </div>
                <div className="col-8">
                  <div className="input-group mb-3">
                    <input onChange={handleInputChange} type="text" className="form-control" placeholder="Pesquisar por nome" aria-describedby="button-addon2"/>
                    <button onClick={(e) => setBusca(texto)} className="btn btn-primary" type="button" id="button-addon2"> <i class="fas fa-search"></i> Pesquisar</button>
                  </div>
                </div>
           </div>
           <ListaClientes arrayClientes={clientes} clickDelete={confirmDeleteUser}/>
           {
           confirmacao ? <SweetAlert
              warning
              showCancel
              showCloseButton
              confirmBtnText="Sim"
              confirmBtnBsStyle="danger"
              cancelBtnText="Não"
              cancelBtnBsStyle="light"
              title="Exclusão"
              onConfirm={() => deleteUser(confirmacaoId)}
              onCancel={() => setConfirmacao(false)}
                reverseButtons={true}
            >
              Deseja exluir o sindicalizado selecionado?
          </SweetAlert> :null
          }
           </div>
        </div>;
  }

  export default Home;